











import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class MenuCard extends Vue {
  @Prop()
  public title!: string;
  @Prop()
  public description!: string;
}
